import { render, staticRenderFns } from "./ClienteHeader.vue?vue&type=template&id=f73e95bc&scoped=true&"
import script from "./ClienteHeader.vue?vue&type=script&lang=js&"
export * from "./ClienteHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClienteHeader.vue?vue&type=style&index=0&id=f73e95bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73e95bc",
  null
  
)

export default component.exports